import { Component } from '@angular/core';
import { dayjs } from 'src/app/dayjs.lib';
import { LocaleService } from '../../../../core/locale/locale.service';

export const ACCESSO_PASSPORT_LOGO_ALT_DEFAULT = 'accesso Passport logo';

@Component({
	selector: 'ahp-login-footer',
	templateUrl: './login-footer.component.html',
	styleUrls: ['./login-footer.component.scss'],
})
export class LoginFooterComponent {
	/**
	 * Build version
	 */
	buildVersion: string = require('../../../../../../package.json').version;
	/**
	 * Display year from the build date
	 */
	buildTimestamp = dayjs().format('YYYY');
	/**
	 * Localized text for accesso Passport logo
	 */
	accessoLogoAltText: string;

	/**
	 * construct the login footer
	 * @param _locale the locale service
	 */
	constructor(private _locale: LocaleService) {
		const logoAltTextLocale = 'accessibility.accessopassportlogoalttext';
		this.accessoLogoAltText = this._locale.has(logoAltTextLocale)
			? this._locale.get(logoAltTextLocale)
			: ACCESSO_PASSPORT_LOGO_ALT_DEFAULT;
	}
}
